import { render } from "./RequisitesPayInDealSumsForm.vue?vue&type=template&id=a4bd83aa&ts=true"
import script from "./RequisitesPayInDealSumsForm.vue?vue&type=script&lang=ts"
export * from "./RequisitesPayInDealSumsForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__